export const settings = [
  {
    group: "field",
    type: "color",
    selector: "field",
    value: "#000"
  },
  {
    group: "field",
    type: "border-color",
    selector: "field",
    value: "#e3e3e3"
  },
  {
    group: "field",
    type: "border-radius",
    selector: "field",
    value: 4
  },
  {
    group: "field",
    type: "font-weight",
    selector: "field",
    value: 400
  },
  {
    group: "button",
    type: "color",
    selector: "button",
    value: "#fff"
  },
  {
    group: "button",
    type: "background-color",
    selector: "button",
    value: "#1677be"
  },
  {
    group: "button",
    type: "border-radius",
    selector: "button",
    value: 4
  },
  {
    group: "button",
    type: "font-weight",
    selector: "button",
    value: 400
  }
]
